import { Chip } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export default function FilterButton(props) {
  const { sector, filters, setFilters } = props;
  const [clicked, setClicked] = useState(null);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  useEffect(() => {
    const filterArray = filters?.Sector?.split("|");
    const filterPresent = filterArray?.find((item) => item === sector);
    setClicked(filterPresent ? true : false);
  }, [filters]);

  return (
    <Chip
      variant="outlined"
      color="primary"
      label={sector}
      style={{
        height: isDesktopOrLaptop ? "40px" : "35px",
        border: !clicked ? "1.5px solid #808080" : "",
        backgroundColor: clicked ? "#0040ff" : "#fff",
        color: clicked ? "#f8f8f8" : "#808080",
        borderRadius: "32.5px",
        marginRight: "25px",
        fontSize: "14px",
        fontWeight: 400,
        boxSizing: "border-box",
        fontFamily: "Overpass",
      }}
      clickable={true}
      onClick={() => {
        if (clicked) {
          var updatedString = filters?.Sector.replace(`|${sector}`, "");
          updatedString = updatedString.replace(`${sector}`, "");
          if (updatedString === "") {
            let newState = { ...filters };
            delete newState?.Sector;
            setFilters(newState);
          } else {
            setFilters({ ...filters, Sector: updatedString });
          }
        } else {
          setFilters(
            filters?.Sector
              ? {
                  ...filters,
                  Sector: `${filters.Sector}|${sector}`,
                }
              : { ...filters, Sector: sector }
          );
        }
        setClicked(!clicked);
      }}
    />
  );
}
